<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <blank-card>
    <span class="title block">{{ title }}</span>
    <span :class="statusColor">
      <information-circle-icon class="h-7 w-7 inline" />
    </span>
    <span class="status-text text-3xl pr-1 font-bold inline">{{ statusText[status] }}</span>
  </blank-card>
</template>

<script>
import BlankCard from '@/Components/Cards/BlankCard'
import { ArrowSmUpIcon, ArrowSmDownIcon, InformationCircleIcon } from '@heroicons/vue/solid'

export default {
  props: {
    /**
     * The larger bolder text that appears at the top of the card
     */
    title: {
      type: String,
      default: 'Status'
    },

    /**
     * Status is a number that acts as an index into the colours and errorText arrays.
     * By default the colours array is ordered like a stop light so you can expect
     * index| colour | text
     * 0    | red    | Error
     * 1    | orange | Warning
     * 2    | green  | Ok
     *
     * If you change the colours array, then you will have to figure out which colour means which yourself
     */
    status: {
      type: Number,
      default: 2
    },

    /**
     * An array of colours that we want to hold statuses for. Use this.status as index
     */
    colours: {
      type: Array,
      default: () => ['red-500', 'yellow-500', 'green-500']
    },

    /**
     * An array of strings to display for each status. Use this.status as index
     */
    statusText: {
      type: Array,
      default: () => ['Error', 'Warning', 'Ok']
    }
  },
  components: { BlankCard, ArrowSmUpIcon, ArrowSmDownIcon, InformationCircleIcon },
  computed: {
    statusColor() {
      let retval = {}
      let chosenColour = `text-${this.colours[this.status]}`
      retval[chosenColour] = true
      retval['mr-2'] = true
      return retval
    }
  }
}
</script>
